"use strict";const e=require("./index-df4084de.js"),s=require("./index-8b6fbbdb.js");function a(t){s.requiredArgs(1,arguments);var r=e.toDate(t);return r.setHours(0,0,0,0),r}exports.startOfDay=a;
